import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {TrackingContext} from '@homeaway/react-event-tracking';

import './ListYourProperty.less';

function ListYourProperty({isInverse, link, text}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);
    const className = classNames(
        'site-header-list-your-property',
        'btn', 'btn-default', 'btn-sm', {
            'btn-inverse': isInverse
        });

    const attrs = {
        className,
        'data-bypass': true,
        href: link,
    };

    function handleClickLYP() {
        const fields = {
            actionlocation: 'header.lyp'
        };
        context.trigger('header.link.click', fields);
    }

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <a {...attrs} target="_blank" onClick={handleClickLYP}>{text}</a>
    );
}

ListYourProperty.propTypes = {
    isInverse: PropTypes.bool,
    text: PropTypes.string.isRequired,
};

ListYourProperty.defaultProps = {
    isInverse: false
};

export {ListYourProperty};
